import { DocumentsClient } from '@src/documents/services/DocumentsClient';
import { useMutation } from '@tanstack/react-query';

type DeleteDocumentParams = {
  documentId: string;
  index: number;
};

export const useDeleteDocument = ({
  onSuccess,
  onError,
}: {
  onSuccess: ({ documentId, index }: DeleteDocumentParams) => void;
  onError: () => void;
}) => {
  const { mutate, isPending } = useMutation({
    mutationFn: async ({ documentId, index }: DeleteDocumentParams) => {
      await DocumentsClient.delete(documentId);
      return { documentId, index };
    },
    onSuccess: ({ documentId, index }: DeleteDocumentParams) =>
      onSuccess({ documentId, index }),
    onError,
  });

  return {
    deleteDocument: mutate,
    isPending,
  };
};
